import { render, staticRenderFns } from "./addMenuEdit.vue?vue&type=template&id=296e565c"
import script from "./addMenuEdit.vue?vue&type=script&lang=js"
export * from "./addMenuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports